/*
 * The most a direct order may cost, excl. VAT. The backend refuses anything above it too
 * (FM-BackEnd-v2 direct-orders/limits.ts); this gives the same answer before submitting.
 */
export const MAX_DO_TOTAL = 10000;

const THOUSANDS = /^\d{1,3}(,\d{3})+(\.\d+)?$/;
const PLAIN = /^\d+(\.\d+)?$/;

/** Same reading as the backend: "9500", "9500.50", "9,500.50", an optional "€". Otherwise null. */
export const parseTotal = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string') return null;
  const text = value.trim().replace(/^(€|eur\b)\s*/i, '').replace(/\s*(€|eur)$/i, '').trim();
  if (THOUSANDS.test(text)) return Number(text.replace(/,/g, ''));
  if (PLAIN.test(text)) return Number(text);
  return null;
};

export const LIMIT_LABEL = `€${MAX_DO_TOTAL.toLocaleString('en-GB')}`;

/** An antd Form rule for any total cost field. Empty values are left to the required rule. */
export const totalLimitRule = {
  validator: (_, value) => {
    if (value === undefined || value === null || value === '') return Promise.resolve();
    const total = parseTotal(value);
    if (total === null) return Promise.reject(new Error('Enter the total as an amount in euro, e.g. 9500.00'));
    if (total > MAX_DO_TOTAL) {
      return Promise.reject(new Error(`Direct orders can't be more than ${LIMIT_LABEL} (excl. VAT)`));
    }
    return Promise.resolve();
  },
};
